export const makeRoutesAccountGuard = ({ ssr, router, store }) => {
	return (to, from, next) => {
		if (!store.get('shop/user')) {
			if (ssr) {
				ssr.responseSent = true
				ssr.res.redirect(302, '/?redirect=' + encodeURIComponent(to.fullPath))
				next(false)
			} else {
				store.set('shop/loginDrawer', true)
			}
		} else {
			next()
		}
	}
}

